import { __decorate, __metadata } from "tslib";
import { Component, Input, Output } from 'angular-ts-decorators';
import template from './faq-search-controls.component.html';
var FaqSearchControlsComponent = (function () {
    function FaqSearchControlsComponent() {
        this.search = { categories: [], query: '' };
    }
    FaqSearchControlsComponent.prototype.ngOnChanges = function () {
        this.reset();
        if (!this.disableSearchByCategory) {
            this.setCategories();
        }
    };
    FaqSearchControlsComponent.prototype.searchParametersChanged = function () {
        if (this.onSearchChange) {
            var _a = this.search, categories = _a.categories, query = _a.query;
            this.onSearchChange({ query: query, categories: categories });
        }
    };
    FaqSearchControlsComponent.prototype.clearSearchQuery = function () {
        this.search.query = '';
        this.searchParametersChanged();
    };
    FaqSearchControlsComponent.prototype.onCategoriesChanged = function (categories) {
        this.search.categories = categories.map(function (x) { return x.key; });
        this.searchParametersChanged();
    };
    FaqSearchControlsComponent.prototype.reset = function () {
        this.search.query = '';
        this.search.categories = [];
    };
    FaqSearchControlsComponent.prototype.setCategories = function () {
        var categoryMap = new Map();
        (this.faqItems || []).forEach(function (faqItem) {
            (faqItem.categories || []).forEach(function (category) {
                if (!categoryMap.has(category.key)) {
                    categoryMap.set(category.key, {
                        items: [],
                        key: category.key,
                        selected: false,
                        title: category.title
                    });
                }
                categoryMap.get(category.key).items.push(faqItem);
            });
        });
        this.faqCategories = Array.from(categoryMap.values());
        this.faqCategories.forEach(function (category) {
            category.items.sort(function (faqItem1, faqItem2) {
                return faqItem1.question.localeCompare(faqItem2.question);
            });
        });
    };
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], FaqSearchControlsComponent.prototype, "searchPlaceholder", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], FaqSearchControlsComponent.prototype, "clearAllCategoriesLabel", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], FaqSearchControlsComponent.prototype, "categoryPlaceholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], FaqSearchControlsComponent.prototype, "disableSearchByCategory", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], FaqSearchControlsComponent.prototype, "faqItems", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Function)
    ], FaqSearchControlsComponent.prototype, "onSearchChange", void 0);
    FaqSearchControlsComponent = __decorate([
        Component({
            selector: 'faqSearchControls',
            template: template,
        })
    ], FaqSearchControlsComponent);
    return FaqSearchControlsComponent;
}());
export { FaqSearchControlsComponent };
